module.exports = __webpack_public_path__ + "static/media/krx-derivatives-seeds-02.46b78a07.jpg";